module.exports = __webpack_public_path__ + "img/add.c39eba55.png";